import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router'
import SignInPage from 'pages/sign-in/SignInPage'
import { useIsLoggedIn } from 'hooks/useIsLoggedIn'

export const Route = createFileRoute('/signin')({
  component: SignInRoute,
})

function SignInRoute() {
  const isLoggedIn = useIsLoggedIn()
  const search = useSearch({ strict: false }) as { redirect?: string }

  if (isLoggedIn) {
    return <Navigate to={search.redirect || '/app'} />
  }

  return <SignInPage />
}
